<template>
  <content-dialog
    v-model="addModalOpen"
    fullscreen-tablet
    title="New Client"
    width="775px"
    max-height="80vh"
    min-height="25vh"
    no-backdrop-dismiss
    :confirm-cancel="onCancelDialog"
    :loading="loadingCreateClient"
    :tags="[helpCodes.createClient, helpCodes.clients]"
    @hide="close"
  >
    <GeneralPartial
      v-if="!!options"
      :options="options"
      :client="newClient"
      :errors="errors"
    />

    <template #bottom>
      <q-toolbar>
        <q-space />
        <q-btn
          color="green"
          icon-right="done"
          label="Create"
          :loading="loadingCreateClient"
          @click="createClient"
        />
      </q-toolbar>
    </template>
  </content-dialog>
</template>

<script>
import GeneralPartial from './partials/edit/panels/General'

import ReferenceNumberMixin from './../../partials/ReferenceNumber'
import PhoneAddressMixin from '../../partials/PhoneAddressEmail'
import awardNewbie from 'src/helpers/awardNewbie'

function defaultClient () {
  return {
    id: null,
    is_individual: true,
    display_name: null,
    first_name: null,
    last_name: null,
    reference_id: null,
    emails: [],
    phones: [],
    website: null,
    addresses: [],
    timezone: null,
    send_email: false,
    note: null,
    image: null,
    default_communication_method: 'EMAIL',
    disable_reminders: false,
    heard_from_via: null,
    role_labels: [],
    industry_labels: [],
    prefer_contact_name: false,
    strata_identifier: null,
    inventory_markup_percentage: 0,
    invoicing_default_due_date: null
  }
}

export default {
  components: {
    GeneralPartial
  },
  mixins: [ReferenceNumberMixin, PhoneAddressMixin],
  emits: ['created'],
  data () {
    return {
      addModalOpen: false,
      loadingCreateClient: false,
      newClient: defaultClient(),
      errors: {},
      options: null
    }
  },
  methods: {
    open () {
      this.addModalOpen = true
      this.newClient = defaultClient()

      const phoneType = this.phoneTypes[0]
      this.newClient.phones.push(this.getPhonePayload(true, {
        type: phoneType.value,
        field_name: phoneType.label
      }))
      const addressType = this.addressTypes[0]
      this.newClient.addresses.push(this.getAddressPayload(true, {
        type: addressType.value,
        field_name: addressType.label
      }))

      const emailType = this.emailTypes[0]
      this.newClient.emails.push(this.getEmailPayload(true, {
        type: emailType.value,
        field_name: emailType.label
      }))
      this.loadNewClientDefaults()
    },
    close () {
      this.newClient = defaultClient()
      this.errors = {}
    },
    onCancelDialog (callback) {
      this.$q.dialog({
        title: 'Confirm',
        message: [
          'Are you sure you want to back?',
          'This client will not be saved and any changes will be lost.'
        ],
        ok: true,
        cancel: true,
        color: 'orange-7'
      })
        .onOk(callback)
    },
    async createClient () {
      if (this.newClient.is_individual) {
        this.newClient.display_name = ((this.newClient.first_name || '') + ' ' + (this.newClient.last_name || '')).trim() || null
      }

      this.loadingCreateClient = true
      this.errors = {}
      const { status, payload, errors } = await this.$post('v1/clients', this.newClient)
      this.loadingCreateClient = false
      if (status === 'success') {
        this.$q.notify({
          message: 'Client successfully created',
          color: 'green'
        })
        await awardNewbie(this.newbies.setupCreateClient, 'user')
        this.$emit('created', payload.client)
        this.addModalOpen = false
      }
      else if (status === 'unsubscribed') {
        this.$unsubscribed({
          hitLimit: true,
          modelName: 'client'
        })
      }
      else {
        this.addModalOpen = true
        this.errors = errors
        this.$nextTick(() => { this.scrollToFirstError(this.$el) })
      }
    },
    async loadNewClientDefaults () {
      this.loadingCreateClient = true
      const { status, payload } = await this.$get('v1/clients/defaults')
      this.loadingCreateClient = false
      if (status === 'success') {
        this.options = payload

        this.newClient.send_email = payload.clients_send_client_connect_request
        this.newClient.disable_reminders = payload.clients_default_disable_reminders
        this.newClient.default_communication_method = payload.clients_default_communication_method
        this.newClient.reference_id = payload.reference_id
      }
    }
  }
}
</script>
